import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
export var IdmsLongIcon = function IdmsLongIcon(props) {
  var _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 104 36' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '104' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '36' : _props$height;
  var classes = useStyles(props);
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: height,
      viewBox: viewBox,
      width: width,
      xmlSpace: "preserve",
      x: "0px",
      y: "0px"
    },
    /*#__PURE__*/
    React.createElement("g", null,
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M41.986 12.343L44.537 12.343 44.537 23.451 41.986 23.451 41.986 25.92 49.752 25.92 49.752 23.451 47.191 23.451 47.191 12.343 49.752 12.343 49.752 9.874 41.986 9.874zM64.8 12.26c-.641-.755-1.447-1.353-2.355-1.748-1.03-.441-2.141-.658-3.261-.638h-6.357V25.92h6.306c1.448.046 2.878-.333 4.114-1.09 1.12-.705 2.016-1.715 2.582-2.911.568-1.264.856-2.636.843-4.022.004-1.048-.159-2.09-.483-3.086-.293-.932-.764-1.799-1.389-2.55zm-9.257.175h3.548c.998-.044 1.985.218 2.829.751.714.496 1.268 1.19 1.594 1.996.348.862.523 1.785.515 2.715.01.94-.166 1.873-.515 2.746-.342.812-.919 1.503-1.656 1.986-.853.52-1.84.774-2.839.73h-3.548l.072-10.924zM76.865 18.226l-5.143-8.352h-2.54V25.92h2.653v-6.593-2.695c0-.854-.061-1.41-.133-2.109l4.32 6.8v.05h1.604l4.454-6.88c-.062.71-.113 1.419-.144 2.129-.03.71-.062 1.748-.062 2.705v6.593h2.654V9.874H82.08l-5.215 8.352zM96.264 17.403c-.816-.385-1.676-.668-2.561-.843-.817-.158-1.605-.443-2.335-.843-.566-.325-.897-.944-.854-1.595-.016-.61.288-1.183.803-1.512.613-.39 1.33-.584 2.057-.555.752-.015 1.492.2 2.119.617.611.423 1.123.974 1.501 1.615l.072.113 1.872-1.841v-.072c-.518-.874-1.27-1.587-2.17-2.057-1.015-.515-2.143-.77-3.281-.74-.941-.01-1.873.18-2.736.555-.81.337-1.52.88-2.057 1.573-.523.696-.798 1.547-.782 2.417-.068 1.226.415 2.418 1.317 3.25 1.038.82 2.265 1.369 3.569 1.595.943.15 1.85.475 2.674.957.585.352.935.993.915 1.676 0 .387-.156.757-.432 1.029-.306.322-.688.562-1.11.7-1.334.451-2.8.277-3.991-.474-.749-.574-1.395-1.27-1.913-2.057l-.072-.103-1.81 2.057v.072c.673 1.01 1.593 1.832 2.674 2.386 1.059.493 2.215.743 3.384.73 1.55.089 3.08-.394 4.299-1.357 1.054-.922 1.633-2.273 1.574-3.672.02-.814-.258-1.608-.782-2.232-.545-.592-1.207-1.065-1.944-1.389zM103.69 9.257c-.303-.492-.84-.792-1.42-.792-.594-.012-1.153.288-1.47.792-.145.246-.22.527-.216.813-.003.285.072.566.216.812.152.24.36.437.607.576.514.288 1.141.288 1.656 0 .244-.14.449-.337.596-.576.152-.243.231-.525.227-.812.015-.284-.053-.567-.196-.813zm-.39 1.399c-.107.172-.256.313-.433.411-.181.104-.387.157-.596.155-.416-.005-.802-.217-1.029-.566-.218-.36-.218-.812 0-1.173.11-.175.262-.32.443-.421.185-.104.394-.157.606-.155.21-.002.415.051.597.155.177.102.326.247.432.421.218.36.218.813 0 1.173h-.02z",
      transform: "translate(-680 -582) translate(640 314) translate(40 268)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M102.96 9.669c.034-.146-.004-.3-.103-.412-.103-.095-.24-.147-.38-.144h-.792v1.708h.411v-.628h.195l.258.669h.432l-.288-.71c.065-.047.12-.107.164-.175.068-.088.105-.197.103-.308zm-.473.174c-.063.022-.132.022-.196 0h-.236v-.329h.247c.068-.001.136.017.195.052.051.029.08.086.072.144-.003.055-.034.106-.082.133z",
      transform: "translate(-680 -582) translate(640 314) translate(40 268)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls2,
      d: "M30.538 5.238c6.983 6.986 6.98 18.31-.004 25.294-6.985 6.983-18.309 6.983-25.294 0-6.985-6.984-6.987-18.308-.005-25.294 6.989-6.984 18.315-6.984 25.303 0",
      transform: "translate(-680 -582) translate(640 314) translate(40 268) translate(0 -.003)"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls3,
      d: "M23.657 9.075c-.418-.42-.986-.655-1.579-.655-.592 0-1.16.236-1.579.655l-8.403 8.413-2.602-2.612c-.224-.227-.568-.285-.854-.144-.288.138-.457.443-.422.761l1.029 9.411 15.14-15.11-.73-.72zM26.67 12.53c-.035-.284-.23-.524-.503-.616-.27-.101-.572-.032-.772.174L11.921 25.563c-.277.287-.277.741 0 1.028.982.974 2.566.974 3.549 0l8.228-8.228 2.603 2.602c.224.223.565.28.85.144.286-.136.456-.436.425-.75l-.905-7.828z",
      transform: "translate(-680 -582) translate(640 314) translate(40 268) translate(0 -.003)"
    })))
  );
};
var useStyles = makeStyles(function (theme) {
  return {
    cls1: function cls1(props) {
      return {
        fill: props.color ? props.color : theme.palette.common.mediumGray
      };
    },
    cls2: function cls2() {
      return {
        fill: theme.palette.product.idms,
        fillRule: 'evenodd'
      };
    },
    cls3: {
      fill: theme.palette.common.white
    }
  };
});